import React from "react";
import { Text, StyleSheet } from "@react-pdf/renderer";
// Estilos para el PDF
const styles = StyleSheet.create({
    textareaLabel: {
        fontSize: 12,
        textAlign: 'justify',
        marginBottom: 8,
        lineHeight: 1.5,
        fontWeight: 'bold', // Para resaltar el texto
        fontFamily: 'Times-Bold',
        marginTop: 10
    }, 
    title_respuesta: {
        fontSize: 12,
        textAlign: 'justify',
        marginBottom: 5,
        fontWeight: 'normal', // Sin negrita
        borderBottomColor: '#000',
        textDecoration: 'underline', // Subraya el texto
        fontWeight: 'normal !important', // Asegura que no tenga negrita
    },
});
const QuestionResponse = ({ label, value }) => {

    return (
        <>
            <Text style={{ marginTop: 10 }}>
                <Text style={styles.textareaLabel}>- {label} </Text>
                <Text style={styles.title_respuesta}>R/. {value || ""}</Text>
            </Text>
        </>
    );
};

export default QuestionResponse;
